/* eslint-disable react-hooks/exhaustive-deps */
import { useParams } from 'react-router';
import { Helmet } from 'react-helmet-async';
import React, { useState, useEffect } from 'react';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';

import { DetailsPageCommon } from 'src/components/details/details';

import ChannelFormHandler from './channelFormHandler';
import { useGetChannelDeatilMutation } from './slice/channelApi';

function ChannelEdit() {
  //local states
  const [currnetChannel, setCurrentChannel] = useState<any>({});

  // api call
  const [getChannelDetail, { isLoading }] = useGetChannelDeatilMutation();

  //selected channel id
  const { id = '' } = useParams();

  //meta data
  const metadata = { title: `Account Details | Account - ${CONFIG.appName}` };

  //translation function
  const { t } = useTranslate('navbar');

  useEffect(() => {
    if (id) {
      getChannelDetail(id)
        .unwrap()
        .then(async (res) => {
          setCurrentChannel(res.data.channel);
        })
        .catch((err) => {
          console.log('error =>', err);
        });
    }
  }, [id]);

  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <DetailsPageCommon
        heading={currnetChannel?.channelName || 'Unknown'}
        backHref={paths.channel.root}
        breadcrumbsLink={[
          { name: `${t('CHANNEL')}`, href: paths.channel.root },
          { name: `Editing ${currnetChannel?.channelName || 'Unknown'}` },
        ]}
        components={<ChannelFormHandler selectedChannel={currnetChannel} isLoading={isLoading} />}
      />
    </>
  );
}

export default ChannelEdit;
